/**
 * Sticky Add-to-Cart bar component.
 *
 * Uses IntersectionObserver to detect when the main ATC button scrolls
 * out of the viewport and toggles visibility of the sticky bar.
 * Mobile only — CSS handles desktop hiding.
 */
class StickyAtcComponent extends HTMLElement {
  /** @type {IntersectionObserver | null} */
  #observer = null;

  connectedCallback() {
    const formId = this.dataset.formId;
    if (!formId) return;

    const form = document.getElementById(formId);
    if (!form) return;

    const target = form.querySelector('button[name="add"]') || form;

    this.#observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry) return;
        this.dataset.visible = entry.isIntersecting ? 'false' : 'true';
      },
      { threshold: 0 }
    );

    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }
}

if (!customElements.get('sticky-atc-component')) {
  customElements.define('sticky-atc-component', StickyAtcComponent);
}
